import React from 'react';
import PropTypes from 'prop-types';
import NotificationsItem from '../NotificationItem/NotificationItem';
import styles from '../NotificationItem/NotificationItem.scss';

const NotificationChangedStatus = ({
  notification,
  close,
  action,
  notificationData,
  staticTexts,
  onClickMarkAsRead,
}) => {
  const capitalizeStatus = () => {
    const status = notification.data.status || '';
    return status.charAt(0).toUpperCase() + status.slice(1);
  };

  return (
    <NotificationsItem
      notification={notification}
      close={close}
      action={action}
      notificationData={notificationData}
      staticTexts={staticTexts}
      onClickMarkAsRead={onClickMarkAsRead}
    >
      <div className={styles.messageQuestion}>
        {notificationData.changedStatus.requestStatusStaticText}
        <span className={styles.requestStatus}>{` '${capitalizeStatus()}'`}</span>
      </div>
    </NotificationsItem>
  )
}

NotificationChangedStatus.propTypes = {
  notification: PropTypes.shape({
    createdAt: PropTypes.string,
    type: PropTypes.string,
    seen: PropTypes.bool,
    data: PropTypes.object,
  }).isRequired,
  close: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
  notificationData: PropTypes.shape({
    changedStatus: PropTypes.shape({
      requestStatusStaticText: PropTypes.string,
      messageStaticText: PropTypes.string,
    })
  }).isRequired,
  staticTexts: PropTypes.shape({
    markAsRead: PropTypes.string,
    markAsUnread: PropTypes.string,
  }).isRequired,
  onClickMarkAsRead: PropTypes.func.isRequired,
};

export default NotificationChangedStatus;
